/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_ngcontent-%COMP%]:root{--mmi-background-color:#eef2f5;--mmi-bottombar-bg-color:#4e5b61;--mmi-bottombar-bg-darken:#354248;--mmi-primary-btn:#F3953F;--mmi-secondary-btn:#58a4c0;--mmi-btn-colour-3:#58a4c0;--mmi-btn-colour-4:#58a4c0;--green-color:#54D89F;--red-color:#EC506E;--login-page-bg-color:#4e5b61}.campaign-terms[_ngcontent-%COMP%]{width:100%}.campaign-terms[_ngcontent-%COMP%]   .buttons[_ngcontent-%COMP%]{margin:10px 45px}.campaign-terms[_ngcontent-%COMP%]   .buttons[_ngcontent-%COMP%]   .button[_ngcontent-%COMP%]{padding:0 5px 0 8px;height:24px;font-size:1.1125rem}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/main/campaigns-add/selectable-campaign-terms/selectable-campaign-terms.component.scss.shim.ngstyle.js.pre-build-optimizer.js